module.exports = __webpack_public_path__ + "assets/Mining.6a17ddb8.svg";